/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchWorkersResponse } from './search-workers-response';


export interface SearchWorkersResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchWorkersResponse> | null;
}

